import { useEffect } from 'react'

import { useRequestProfileContext } from '../useRequestProfileContext'

export function useRequestProfileTabPerformingAction(isPerformingAction) {
  const { setPerformingAction } = useRequestProfileContext()

  useEffect(() => {
    setPerformingAction(isPerformingAction)

    return () => {
      setPerformingAction(false)
    }
  }, [isPerformingAction])
}
